const LEGACY_TEAM_FIELDS = ['teamId', 'departmentId', 'department']

/** A chosen canonical team replaces stale aliases retained by older flow definitions. */
export const serializeCallFlowTeams = (
  definition: Record<string, unknown>,
): Record<string, unknown> => {
  const visit = (value: unknown): unknown => {
    if (Array.isArray(value)) return value.map(visit)
    if (!value || typeof value !== 'object') return value
    const record = value as Record<string, unknown>
    const hasCanonicalTeam =
      Object.prototype.hasOwnProperty.call(record, 'team') &&
      (typeof record.team === 'string' || record.team === null)
    return Object.fromEntries(
      Object.entries(record)
        .filter(
          ([key]) => !(hasCanonicalTeam && LEGACY_TEAM_FIELDS.includes(key)),
        )
        .map(([key, child]) => [key, visit(child)]),
    )
  }
  return visit(definition) as Record<string, unknown>
}
